import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateEditContent from './CreateEditContent';
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { SLEditModal, SLCreateModal } from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';

export default function Contrato() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check').then(response => setModulos(response.data));
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: filters => {
                return api.get('/signed/empresa/suporte/contratos', {
                  params: filters,
                });
              },
              findOne: thisData =>
                api.get('/signed/empresa/suporte/contrato', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/suporte/contrato', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Contrato',
              subTitle: 'Adicione as Contratos',
              icone: 'menu-contrato',
              menu: true,
            }}
            inputs={[
              { filter: 'nomeFantasia', label: 'Título', type: 'text' },
              { filter: 'id', label: 'ID', type: 'number' },
            ]}
          >
            <SLEditModal menu={true} title="Atualizar Contrato" setter={setMountedData}>
              {mountedData && modulos && <CreateEditContent {...{ mountedData }} />}
            </SLEditModal>

            <SLCreateModal menu={true} title="Adicionar Contrato">
              {modulos && <CreateEditContent {...{ modulos }} />}
            </SLCreateModal>

            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
